import React, { useEffect, useRef, useState } from "react";
import { Check, ChevronDown, Database } from "lucide-react";
import { NEXT_SELLER_SOURCES } from "./nextSellerSources";

export const NextSellerSourceFilter = ({ value, onChange, testIdPrefix = "next-seller-source-filter" }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    useEffect(() => {
        const close = (event) => { if (!rootRef.current?.contains(event.target)) setOpen(false); };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);
    const toggle = (sourceId) => onChange(value.includes(sourceId) ? value.filter((item) => item !== sourceId) : [...value, sourceId]);
    return (
        <div ref={rootRef} className="next-seller-source-filter">
            <span className="vd-field-label">Fonte</span>
            <button data-testid={`${testIdPrefix}-trigger`} type="button" aria-expanded={open} onClick={() => setOpen(!open)} className="next-seller-source-trigger">
                <Database size={15} />
                <span data-testid={`${testIdPrefix}-summary`}>{value.length === NEXT_SELLER_SOURCES.length ? "Tutte le fonti" : `${value.length} fonti selezionate`}</span>
                <ChevronDown size={15} className={open ? "rotate-180" : ""} />
            </button>
            {open && (
                <div data-testid={`${testIdPrefix}-menu`} role="listbox" aria-multiselectable="true" className="next-seller-source-menu">
                    {NEXT_SELLER_SOURCES.map((source) => {
                        const checked = value.includes(source.id);
                        return (
                            <button data-testid={`${testIdPrefix}-${source.id}`} key={source.id} type="button" role="option" aria-selected={checked} onClick={() => toggle(source.id)} className="next-seller-source-option">
                                <span className={`next-seller-source-check ${checked ? "is-selected" : ""}`}>{checked && <Check size={12} />}</span>
                                <span>{source.label}</span>
                                {source.priority && <small className="next-seller-source-priority">{source.priority}</small>}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};